import React from 'react';
import FundLevelTree from './FundLevelTree';
import FundInvestorTagLevelTreeContainer from './FundInvestorTagTree/FundInvestorTagLevelTreeContainer';

const FundStep = props => {
  if (
    props.fundLevelDocumentsChecked === true ||
    props.bulkMode ||
    !props.isFundLevelFlowAvailable
  ) {
    return <FundLevelTree {...props} />;
  } else return <FundInvestorTagLevelTreeContainer {...props} />;
};

export default FundStep;
